var map = {
	"./Black_Account_Icons-01.png": 679,
	"./Black_Account_Icons-02.png": 680,
	"./Black_Account_Icons-03.png": 681,
	"./Black_Account_Icons-04.png": 682,
	"./Black_Account_Icons-05.png": 683,
	"./Black_Account_Icons-06.png": 684,
	"./Black_Account_Icons-07.png": 685,
	"./Black_Account_Icons-08.png": 686,
	"./Black_Account_Icons-09.png": 687,
	"./Black_Account_Icons-10.png": 688,
	"./Black_Account_Icons-11.png": 689,
	"./Black_Account_Icons-12.png": 690,
	"./Black_Account_Icons-13.png": 691,
	"./Black_Account_Icons-14.png": 692,
	"./FilePresentOutlined.svg": 693,
	"./accuracyAccountsDemo_downloadMT4.jpg": 694,
	"./accuracyAccountsReal_downloadMT4.jpg": 695,
	"./alert@2x.svg": 696,
	"./apple-brands.svg": 697,
	"./arrow_up_from_box.svg": 698,
	"./bankWire.svg": 699,
	"./bdswissDemo_downloadMT4.png": 700,
	"./bdswissGlobalDemo_downloadMT4.png": 701,
	"./bdswissGlobalReal02_downloadMT4.png": 702,
	"./bdswissGlobalReal03_downloadMT4.png": 703,
	"./bdswissGlobalReal04_downloadMT4.png": 704,
	"./bdswissGlobalReal05_downloadMT4.png": 705,
	"./bdswissGlobalReal_downloadMT4.png": 706,
	"./bdswissGlobalReal_downloadMT5.png": 707,
	"./bdswissReal02_downloadMT4.png": 708,
	"./bdswissReal03_downloadMT4.png": 709,
	"./bdswissReal04_downloadMT4.png": 710,
	"./bdswissReal05_downloadMT4.png": 711,
	"./bdswissReal_downloadMT4.png": 712,
	"./bdswissReal_downloadMT5.png": 713,
	"./bdswissSCDemo_downloadMT4.png": 714,
	"./bdswissSCReal01_downloadMT4.png": 715,
	"./bdswissSCReal02_downloadMT4.png": 716,
	"./bdswissSCReal03_downloadMT4.png": 717,
	"./bdswissSCReal04_downloadMT4.png": 718,
	"./bdswissSCReal05_downloadMT4.png": 719,
	"./bdswiss_grey.png": 720,
	"./bdswiss_white.png": 721,
	"./bg-image-affiliate.png": 722,
	"./bitwallet-bdSwiss-dark.svg": 723,
	"./bitwallet-bdSwiss-light.svg": 724,
	"./bitwallet-swissMarkets-dark.svg": 725,
	"./bitwallet-swissMarkets-light.svg": 726,
	"./card.svg": 727,
	"./check_circle.png": 728,
	"./chf.png": 729,
	"./competitions.png": 730,
	"./complimentary@2x.svg": 731,
	"./control-radio-off.png": 732,
	"./control-radio-on.png": 733,
	"./crypto.svg": 734,
	"./cvv.svg": 735,
	"./deposit-card.svg": 736,
	"./diners.png": 737,
	"./dkk.png": 738,
	"./document-upload-failure-dark.png": 739,
	"./document-upload-failure-light.png": 740,
	"./document-upload-success-black.png": 741,
	"./document-upload-success-dark.png": 742,
	"./document-upload-success-light.png": 743,
	"./documents-empty-dark.png": 744,
	"./documents-empty-light.png": 745,
	"./downloadPdf-light.png": 746,
	"./downloadPdf.png": 747,
	"./dpWorldTourChampionship-dark.svg": 748,
	"./dpWorldTourChampionship-light.svg": 749,
	"./eWallet.svg": 750,
	"./eur.png": 751,
	"./exp-date.svg": 752,
	"./fees@2x.svg": 753,
	"./filterIcon.png": 754,
	"./gbp.png": 755,
	"./icon-add-account.svg": 450,
	"./icon-appstore@2x.png": 756,
	"./icon-arrow-right-dark.png": 757,
	"./icon-arrow-right-light.png": 758,
	"./icon-bank-wire.svg": 759,
	"./icon-checkbox.svg": 760,
	"./icon-close-dark.svg": 761,
	"./icon-close-light.svg": 762,
	"./icon-close.png": 763,
	"./icon-contact-callback@2x.png": 764,
	"./icon-contact-callback@2x.svg": 765,
	"./icon-contact-chat@2x.png": 451,
	"./icon-contact-chat@2x.svg": 452,
	"./icon-contact-email@2x.png": 766,
	"./icon-contact-email@2x.svg": 767,
	"./icon-contact-faqs@2x.png": 768,
	"./icon-contact-faqs@2x.svg": 769,
	"./icon-contact-oneOnOneSession@2x.png": 770,
	"./icon-contact-telegram@2x.png": 771,
	"./icon-contact-whatsapp@2x.png": 772,
	"./icon-crypto.svg": 773,
	"./icon-document.svg": 774,
	"./icon-facebook@2x.png": 775,
	"./icon-google-play@2x.png": 776,
	"./icon-notification.svg": 777,
	"./icon-profile-big.svg": 778,
	"./icon-profile.svg": 779,
	"./icon-spoa.svg": 780,
	"./icon-swapFree.svg": 781,
	"./icon-telegram@2x.png": 782,
	"./icon-twitter@2x.png": 783,
	"./icon_accounts_dashboard.svg": 784,
	"./icon_logout_dashboard.svg": 785,
	"./icon_notification_dashboard.svg": 786,
	"./icon_profilesettings_dashboard.svg": 787,
	"./icon_support_dashboard.svg": 788,
	"./icon_transaction_dashboard.svg": 789,
	"./jcb.png": 790,
	"./knet-logo.png": 453,
	"./languages.png": 791,
	"./limit-failure-dark.png": 792,
	"./limit-failure-light.png": 793,
	"./logo-accuracy.png": 794,
	"./logo-bdstrading-white.svg": 795,
	"./logo-bdstrading.svg": 796,
	"./logo-bdswiss-white.svg": 797,
	"./logo-bdswiss.png": 798,
	"./logo-bdswiss.svg": 799,
	"./logo-equityflow-black.png": 800,
	"./logo-equityflow-white.png": 801,
	"./logo-facebook.png": 802,
	"./logo-google.png": 803,
	"./logo-google.svg": 804,
	"./logo-lydian-black.png": 805,
	"./logo-lydian-black.svg": 806,
	"./logo-lydian-white.svg": 807,
	"./logo-regalx-white.png": 808,
	"./logo-regalx.png": 809,
	"./logo-skyground-black.svg": 810,
	"./logo-skyground-white.svg": 811,
	"./logo-swissmarkets-white.svg": 812,
	"./logo-swissmarkets.png": 813,
	"./logo-swissmarkets.svg": 814,
	"./logo-tauromarkets-black.png": 815,
	"./logo-tauromarkets-white.png": 816,
	"./logo-tauromarkets-white2.png": 817,
	"./logo-tauromarkets-white2.svg": 818,
	"./logo-valutamarkets.png": 819,
	"./lydian/login-bg.png": 1376,
	"./lydian/logo.svg": 1377,
	"./lydian/lydian-trading-academy-coming_soon.png": 1378,
	"./lydian/lydian-trading-academy.png": 1379,
	"./lydian/lydian-watermark.png": 475,
	"./lydian/trading-academy-logo.svg": 476,
	"./lydian/user-icon.svg": 1380,
	"./maestro.png": 820,
	"./mastercard.png": 821,
	"./mastercard_logo_icon.svg": 822,
	"./mercedesCup-dark.svg": 823,
	"./mercedesCup-light.svg": 824,
	"./mobile/accounts.svg": 1381,
	"./mobile/more.svg": 1382,
	"./mobile/notifications.svg": 1383,
	"./mobile/payments.svg": 1384,
	"./nationalIdBR.png": 825,
	"./nationalIdES.jpg": 826,
	"./nationalIdIT.jpg": 827,
	"./nationalIdZA.png": 828,
	"./no-trades-dark.png": 829,
	"./no-trades-light.png": 830,
	"./no-trading-signals-dark.png": 831,
	"./nok.png": 832,
	"./notifications-empty-dark.png": 833,
	"./notifications-empty-light.png": 834,
	"./onlineBanking.svg": 835,
	"./onlineDeposit.svg": 836,
	"./page-not-found-dark.svg": 454,
	"./page-not-found-light.svg": 455,
	"./payment-failure-dark.png": 837,
	"./payment-failure-light.png": 838,
	"./payment-pending-dark.png": 839,
	"./payment-pending-light.png": 840,
	"./payment-success-dark.png": 841,
	"./payment-success-light.png": 842,
	"./payments-history-empty-dark.png": 843,
	"./payments-history-empty-light.png": 844,
	"./phone_verification.png": 845,
	"./place1-leadership.png": 846,
	"./place2-leadership.png": 847,
	"./place3-leadership.png": 848,
	"./pln.png": 849,
	"./pof-bankStatement.png": 850,
	"./pof-bankStatementPOF.png": 851,
	"./pof-card-back.png": 852,
	"./pof-card.png": 853,
	"./pof-cardStatement.png": 854,
	"./pof-other.png": 855,
	"./pof-proofOfResidence.png": 856,
	"./pof-swiftCopyPaymentAdvice.png": 857,
	"./pof-virtualCard.png": 858,
	"./poi-document.png": 859,
	"./poi-drivingLicense-back.png": 860,
	"./poi-drivingLicense.png": 861,
	"./poi-id-back.png": 862,
	"./poi-id.png": 863,
	"./poi-passport.png": 864,
	"./por-bankStatementPOR.png": 865,
	"./por-document.png": 866,
	"./por-proofOfResidence.png": 867,
	"./por-utilityBill.png": 868,
	"./priority@2x.svg": 869,
	"./referAndEarn.png": 870,
	"./regalxDemo_downloadMT4.png": 871,
	"./regalxReal01_downloadMT4.png": 872,
	"./regalxReal02_downloadMT4.png": 873,
	"./regalxReal03_downloadMT4.png": 874,
	"./regalxReal04_downloadMT4.png": 875,
	"./regalxReal05_downloadMT4.png": 876,
	"./register-referral-light.png": 877,
	"./sek.png": 878,
	"./sign-up.png": 879,
	"./spaceship.png": 880,
	"./spreads@2x.svg": 881,
	"./support@2x.svg": 882,
	"./swissmarketsDemo_downloadMT4.png": 883,
	"./swissmarketsReal02_downloadMT4.png": 884,
	"./swissmarketsReal_downloadMT4.png": 885,
	"./tauroDemo01DownloadMT4.jpg": 886,
	"./tauroReal01DownloadMT4.jpg": 887,
	"./technicalIndicator-ebook.png": 888,
	"./technicalIndicatorItem.svg": 889,
	"./telegram-dark.png": 890,
	"./telegram.png": 891,
	"./trading-alerts-tradingAlerts-dark.png": 892,
	"./trading-alerts-tradingAlerts-light.png": 893,
	"./tradingPsychology-ebook.png": 894,
	"./tradingPsychologyItem.svg": 895,
	"./transfer-external.svg": 896,
	"./transfer-internal.svg": 897,
	"./transfer-spoa.svg": 898,
	"./unlockYourTradingPotentialBanner/education_desktop.webp": 604,
	"./unlockYourTradingPotentialBanner/education_mobile.webp": 605,
	"./upload-bankStatement-error.png": 899,
	"./upload-bankStatement-success.png": 900,
	"./upload-bankStatement.png": 901,
	"./upload-document-dark.png": 902,
	"./upload-document-light.png": 903,
	"./upload-generic-error.png": 904,
	"./upload-generic-success.png": 905,
	"./upload-generic.png": 906,
	"./upload-pof-back-card-error.png": 907,
	"./upload-pof-back-card-success.png": 908,
	"./upload-pof-back-card.png": 909,
	"./upload-pof-front-card-error.png": 910,
	"./upload-pof-front-card-success.png": 911,
	"./upload-pof-front-card.png": 912,
	"./upload-poi-back-drivingLicense-error.png": 913,
	"./upload-poi-back-drivingLicense-success.png": 914,
	"./upload-poi-back-drivingLicense.png": 915,
	"./upload-poi-back-error.png": 916,
	"./upload-poi-back-success.png": 917,
	"./upload-poi-back.png": 918,
	"./upload-poi-front-drivingLicense-error.png": 919,
	"./upload-poi-front-drivingLicense-success.png": 920,
	"./upload-poi-front-drivingLicense.png": 921,
	"./upload-poi-front-error.png": 922,
	"./upload-poi-front-success.png": 923,
	"./upload-poi-front.png": 924,
	"./upload-por-front-error.png": 925,
	"./upload-por-front-proofOfResidence-error.png": 926,
	"./upload-por-front-proofOfResidence-success.png": 927,
	"./upload-por-front-proofOfResidence.png": 928,
	"./upload-por-front-success.png": 929,
	"./upload-por-front-utilityBill-error.png": 930,
	"./upload-por-front-utilityBill-success.png": 931,
	"./upload-por-front-utilityBill.png": 932,
	"./upload-por-front.png": 933,
	"./usd.png": 934,
	"./visa.png": 935,
	"./visa_logo_icon.svg": 936,
	"./vps-enter-credentials.png": 937,
	"./vps-remote-desktop-windows.png": 938,
	"./vps-remote-desktop.png": 939,
	"./waiting-list-skip-dark.png": 940,
	"./waiting-list-skip.png": 941,
	"./windows-brands.svg": 942
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 945;